import React from 'react';
import { DNABox, DNAText, DNACard, useTheme } from '@alucio/lux-ui';
import { DNACustomFieldChipList, DNADocumentThumbnail } from 'src/components/DNA';
import { DocumentORM } from 'src/types/types';
import { DNACardComponent } from 'src/components/DNA/Grid/Cards/types';

export const DNADocumentVirtualCard: DNACardComponent<DocumentORM> = (props) => {
  const { ORM: documentORM, onPress } = props
  const theme = useTheme()

  const canPresent = documentORM.meta.permissions.MSLPresent;

  return (
    <DNABox
      alignX="start"
      style={[{ minWidth: 232, minHeight: 188 }, !canPresent && { opacity: 0.4 }]}
    >
      <DNACard
        interactive="pressable"
        onPress={() => { onPress?.(documentORM) }}
        style={{
          padding: 8,
          backgroundColor: theme['color-dark-300'],
        }}
      >
        <DNABox appearance="col" spacing="sm">
          <DNABox style={{ backgroundColor: 'rgb(0, 0, 0)' }}>
            <DNADocumentThumbnail
              documentVersionORM={documentORM.relations.version.latestUsableDocumentVersionORM}
              width={216}
              height={124}
            />
          </DNABox>
          <DNABox appearance="row" spacing="sm">
            <DNACustomFieldChipList documentVersionORM={documentORM.relations.version.latestUsableDocumentVersionORM} />
            <DNAText
              colorMode="dark"
              style={{ width: 183, overflow: 'hidden' }}
              numberOfLines={2}
            >
              {documentORM.relations.version.latestUsableDocumentVersionORM.model.title}
            </DNAText>
          </DNABox>
        </DNABox>
      </DNACard>
    </DNABox>
  );
}

export default DNADocumentVirtualCard
